<template>
  <div id="main-layout" class="relative">
    <main-header />
    <a href="#content" class="accessibly-hidden">Skip to Content</a>
    <main id="content">
      <v-app>
        <router-view />
      </v-app>
    </main>
    <tracking />
    <main-footer />
  </div>
</template>

<script>
import Vue from 'vue'
import MainHeader from '@/components/Header'
import Tracking from '@/components/Tracking'
import MainFooter from '@/components/Footer'

import Vuetify, { VApp, VForm, VTextField, VIcon, VBtn, VSelect, VTextarea, VSheet, VChip, VCard, VCardTitle, VExpansionPanel, VExpansionPanelContent, VContainer, VLayout, VFlex, VList, VListTile, VListTileAction, VListTileContent, VListTileTitle, VListTileSubTitle } from 'vuetify/lib'

// Enable Vuetify
Vue.use(Vuetify, { components: { VApp, VForm, VTextField, VIcon, VBtn, VSelect, VTextarea, VSheet, VChip, VCard, VCardTitle, VExpansionPanel, VExpansionPanelContent, VContainer, VLayout, VFlex, VList, VListTile, VListTileAction, VListTileContent, VListTileTitle, VListTileSubTitle } })

export default {
  name: 'MainLayout',
  components: {
    MainHeader,
    MainFooter,
    Tracking
  }
}
</script>

<style lang="scss" scoped>
  #main-layout {
    overflow-x: hidden;
  }

  #content {
    background-color: $white;
  }
</style>
